import { readQueryParamNumber } from "/Helpers/readQueryParam";
import { CallForProposalsResultsProps } from "/Models/Generated/CallForProposalsResultsProps";

export default class CallForProposalsListClient {
  constructor(
    private endpoint: string,
    private language: string,
    private pageId: number,
  ) {}

  public GetItems = (
    pageNumber: number,
    selectedTab: string,
  ): Promise<CallForProposalsResultsProps> => {
    return fetch(
      `${this.endpoint}?pageNumber=${pageNumber}&language=${this.language}&pageId=${this.pageId}&selectedTab=${selectedTab}`,
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error from event list API");
        }
        return response.json();
      })
      .catch((error) => {
        //gracefull return
        return { error: true, message: error.message };
      });
  };

  public BuildUrlFromProps = (
    pageNumber: number,
    selectedTab: string,
  ): string | undefined => {
    const url = window.location.href.split("?")[0].split("#")[0];
    return url + `?tab=${selectedTab}&page=${pageNumber}`;
  };

  private GetPageNumberFromUrl = (): number =>
    readQueryParamNumber("page") ?? 1;

  public GetParams = () => {
    return {
      pageNumber: this.GetPageNumberFromUrl(),
    };
  };
}
